import AssignSpaces from "./AssignSpaces";

export { AssignSpaces };
